import axiosInstance from '../request';
import { pickDevParams } from '../../utils/config';

export const pagesList = (query) => axiosInstance.get('/appearance/pages/list', { params: { ...pickDevParams, ...query } });
export const pagesView = (id) => axiosInstance.get(`/appearance/pages/view/${id}`, { params: pickDevParams });
export const pagesLanguagesActive = () => axiosInstance.get('/appearance/languages/active/list', { params: pickDevParams });
export const pagesToggle = (id, visible) => axiosInstance.post(`/appearance/pages/toggle/visibility/${id}`, { ...pickDevParams, visible });
export const pagesDelete = (id) => axiosInstance.post(`/appearance/pages/delete/${id}`, { ...pickDevParams });
export const pagesEdit = (id, data) => axiosInstance.post(`/appearance/pages/edit/${id}`, { ...data, ...pickDevParams });
export const pagesCreate = (data) => axiosInstance.post('/appearance/pages/create', { ...data, ...pickDevParams });
